import { makeAutoObservable } from "mobx";
import {
  DbotEventDispatcher,
  DocumentContext,
  mapDocumentLanguageToLocales,
  mapLocalesToDocumentLanguage,
} from "../common/commonDomain";
import { Language } from "../../i18n/languages";
import { DocumentLanguage } from "../../common/common";
import { DocumentType } from "../../common/documents";
import {
  RadioFieldModel,
  requiredOfficialDocumentLanguageFieldModel,
} from "../../common/commonForms";

export type ArticlesOfAssociation = {
  type: DocumentType.articlesofassociation;
  documentLanguage: Language[];
};

export class ArticlesOfAssociationForm {
  readonly type = DocumentType.articlesofassociation;
  documentLanguage: RadioFieldModel<DocumentLanguage>;

  constructor(public data: ArticlesOfAssociation) {
    makeAutoObservable(this, { data: false }, { autoBind: true });

    this.documentLanguage = requiredOfficialDocumentLanguageFieldModel({
      value: mapLocalesToDocumentLanguage(data?.documentLanguage),
    });
  }
}

export function initNewForm(
  _: DbotEventDispatcher,
  context: DocumentContext<ArticlesOfAssociation>,
): ArticlesOfAssociationForm {
  return new ArticlesOfAssociationForm(context.documentData);
}

export function applyForm(form: ArticlesOfAssociationForm): ArticlesOfAssociation {
  return {
    type: DocumentType.articlesofassociation,
    documentLanguage: mapDocumentLanguageToLocales(form.documentLanguage.value),
  };
}
